// Pure helper for the housekeeping-plan dialog's real-time capacity indicator.
// Given the BE-authoritative free-slots count and the container count the user
// is trying to plan, produce the severity tone + structured numbers the
// <Alert> needs. Extracted from CreateHousekeepingPlanDialog so the math is unit
// testable without rendering MUI.

export type CapacitySeverity = 'success' | 'warning'

export interface CapacityState {
  severity: CapacitySeverity
  fitsAll: boolean
  // Number of containers that will NOT fit. Never negative.
  deficit: number
}

export const capacityState = (freeSlots: number, containerCount: number): CapacityState => {
  const safeFree = Math.max(freeSlots, 0)
  const safeCount = Math.max(containerCount, 0)
  const fitsAll = safeFree >= safeCount
  return {
    severity: fitsAll ? 'success' : 'warning',
    fitsAll,
    deficit: fitsAll ? 0 : safeCount - safeFree,
  }
}
